import { render, staticRenderFns } from "./offiaccount.vue?vue&type=template&id=9a067c98&scoped=true&"
import script from "./offiaccount.vue?vue&type=script&lang=js&"
export * from "./offiaccount.vue?vue&type=script&lang=js&"
import style0 from "./offiaccount.vue?vue&type=style&index=0&id=9a067c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a067c98",
  null
  
)

export default component.exports